<template>
    <div>
        <ul class="gantt-controls">
            <li class="gantt-menu-item">
                <a data-action="collapseAll"> Collapse All</a>
            </li>
            <li class="gantt-menu-item gantt-menu-item-last">
                <a data-action="expandAll">Expand All</a>
            </li>
            <li class="gantt-menu-item">
                <a data-action="undo">Undo</a>
            </li>
            <li class="gantt-menu-item gantt-menu-item-last">
                <a data-action="redo">Redo</a>
            </li>
            <!--<li class="gantt-menu-item">-->
                <!--<a data-action="toggleAutoScheduling">Auto Scheduling</a>-->
            <!--</li>-->
            <!--<li class="gantt-menu-item">-->
                <!--<a data-action="toggleCriticalPath">Critical Path</a>-->
            <!--</li>-->
            <li class="gantt-menu-item gantt-menu-item-right">
                <a data-action="fullscreen">Fullscreen</a>
            </li>
            <li class="gantt-menu-item gantt-menu-item-right gantt-menu-item-last">
                <a data-action="zoomToFit">Zoom to
                    Fit</a>
            </li>
            <li class="gantt-menu-item gantt-menu-item-right">
                <a data-action="zoomOut"> Zoom Out</a>
            </li>
            <li class="gantt-menu-item gantt-menu-item-right">
                <a data-action="zoomIn">Zoom In</a>
            </li>
            <li class="gantt-menu-item gantt-menu-item-right gantt-menu-item-last">
                <a>Export</a>
                <ul class="gantt-controls">
                    <li class="gantt-menu-item"><a data-action="toPDF">PDF</a></li>
                    <li class="gantt-menu-item"><a data-action="toPNG">PNG</a></li>
                    <li class="gantt-menu-item"><a data-action="toExcel">Excel</a></li>
                    <li class="gantt-menu-item"><a data-action="toMSProject">MS Project</a></li>
                </ul>
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        name: "gantt-menu"
    }
</script>
<style scoped>
    @import "~dhtmlx-gantt/codebase/dhtmlxgantt.css";
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/gantt/GanttMenu.vue